import axios from 'axios'

export default class TipoFederacao {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoFederacao`
    this.tokenBearer = tokenBearer
  }

  getTipoFederacao () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoFederacao = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoFederacao = await axios(optionsTipoFederacao)
        resolve(responseTipoFederacao)
      } catch (err) {
        reject(err)
      }
    })
  }
}
